import SimpleBundleCard from "./SimpleBundleCard";
import InfiniteOptionsWidget from "./InfiniteOptionsWidget";
import ByobGrid from "./ByobGrid";

export default function DemoShowcase({ bundles }) {
  const simple = bundles.filter((bundle) => bundle.type === "SimpleBundle");
  const infinite = bundles.filter((bundle) => bundle.type === "InfiniteOptionsBundle");
  const byob = bundles.filter((bundle) => bundle.type === "ByobBundle");

  return (
    <div className="space-y-24">
      {simple.length > 0 && (
        <section id="simple" className="scroll-mt-24">
          <SectionHeader
            kicker="Simple Bundles"
            title="Fixed kits, ready to sell"
            blurb="One add-to-cart, one price, built-in savings. These ship as a single kit and sync inventory automatically."
          />
          <div className={`grid grid-cols-1 gap-6 ${simple.length > 1 ? "lg:grid-cols-3 md:grid-cols-2" : "max-w-md mx-auto"}`}>
            {simple.map((bundle) => (
              <div key={bundle.id} data-reveal>
                <SimpleBundleCard bundle={bundle} />
              </div>
            ))}
          </div>
        </section>
      )}

      {infinite.length > 0 && (
        <section id="infinite" className="scroll-mt-24">
          <SectionHeader
            kicker="Infinite Options"
            title="Sets your customers personalize"
            blurb="Swatches and rich dropdowns, straight from your variants and categories. Try clicking around. Prices and previews update live."
          />
          <div className="space-y-10">
            {infinite.map((bundle) => (
              <div key={bundle.id} data-reveal>
                <InfiniteOptionsWidget bundle={bundle} />
              </div>
            ))}
          </div>
        </section>
      )}

      {byob.length > 0 && (
        <section id="byob" className="scroll-mt-24">
          <SectionHeader
            kicker="Build-Your-Own"
            title="A bundle builder, with your products in it"
            blurb="Pick a pack size, fill the grid, watch the discount unlock. This is the experience your customers would get."
          />
          <div className="space-y-10">
            {byob.map((bundle) => (
              <div key={bundle.id} data-reveal>
                <ByobGrid bundle={bundle} />
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}

function SectionHeader({ kicker, title, blurb }) {
  return (
    <div className="mb-8 max-w-2xl" data-reveal>
      <p className="kicker mb-3">{kicker}</p>
      <h2 className="display text-3xl sm:text-4xl">{title}</h2>
      <p className="mt-3 leading-relaxed text-ink-soft">{blurb}</p>
    </div>
  );
}
